"use client";
import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import LottieFileInPage from "../../lib/lottie-files/LottieFileInPage";
import SvgHomePage from "../../lib/lottie-files/SvgHomePage";
import { useTranslation } from "@/hooks/localization/useTranslations";

const EmptyCategory = () => {
  const t = useTranslation();
  const router = useRouter();
  return (
    <LottieFileInPage
      lottieFileType={LottieFileTypes.no_products}
      title={t.no_products}
      text={t.sorry_no_products_in_category}
      button={{
        onClick: () => router.push("/"),
        content: (
          <>
            <SvgHomePage />
            {t.go_to_home_page}
          </>
        ),
      }}
    />
  );
};

export default EmptyCategory;
